module.exports = __webpack_public_path__ + "img/special.aa15d3b4.png";